
import { ITempPlannedPortfoliosState } from './../../state/temp-planned-portfolios.state';
import * as PlannedPortfoliosActions from './../actions/planned-portfolios.actions';
import * as ModelPortfoliosActions from './../../model-portfolios/actions/model-portfolios.actions';
import { initialTempPlannedPortfoliosState } from '../../state/temp-planned-portfolios.state';
import { tempPlannedPortfolioAdapter } from '../selectors/temp-planned-portfolios.selectors';
import { IModelPortfolioSubscription } from 'src/app/models/plannedPortfolios';

export function TempPlannedPortfoliosReducer(state = initialTempPlannedPortfoliosState, action: PlannedPortfoliosActions.PlannedPortfoliosActions | ModelPortfoliosActions.ModelPortfoliosActions): ITempPlannedPortfoliosState {
    switch (action.type) {
        case PlannedPortfoliosActions.PlannedPortfoliosActionTypes.SELECT_TEMP_PLANNED_PORTFOLIO:
            return {
                ...state,
                loading: true,
                selectedSubscriptionId: action.payload.subscriptionId
            };
        case PlannedPortfoliosActions.PlannedPortfoliosActionTypes.SELECT_PLANNED_PORTFOLIO_SUCCESS:
        case PlannedPortfoliosActions.PlannedPortfoliosActionTypes.SELECT_PLANNED_PORTFOLIO_FAIL:
            const selectPlannedPortfolioSuccessState = {
                ...state
            };
            return tempPlannedPortfolioAdapter.removeOne(action.payload.selectedTempPlannedPortfolio.subscriptionId, selectPlannedPortfolioSuccessState);
        case PlannedPortfoliosActions.PlannedPortfoliosActionTypes.SUBMIT_PLANNED_PORTFOLIO_SUCCESS:
            const submitPlannedPortfolioSuccessState = {
                ...state
            };
            return tempPlannedPortfolioAdapter.removeOne(action.payload.subscriptionId, submitPlannedPortfolioSuccessState);
        case PlannedPortfoliosActions.PlannedPortfoliosActionTypes.SELECT_TEMP_PLANNED_PORTFOLIO_SUCCESS:
        case PlannedPortfoliosActions.PlannedPortfoliosActionTypes.SELECT_TEMP_PLANNED_PORTFOLIO_FAIL:
            const newState = {
                ...state,
                loading: false
            };
            return tempPlannedPortfolioAdapter.upsertOne({
                ...action.payload.selectedTempPlannedPortfolio,
                positions: [
                    ...action.payload.selectedTempPlannedPortfolio.positions
                ]
                ,
                id: action.payload.selectedTempPlannedPortfolio.subscriptionId
            }, newState);
        case ModelPortfoliosActions.ModelPortfoliosActionTypes.APPLY_MODEL_PORTFOLIO_SUCCESS:
            const rebalancedState = {
                ...state,
                loading: false
            };
            return tempPlannedPortfolioAdapter.upsertMany(action.payload.rebalancedPlannedPortfolios, rebalancedState);
        case PlannedPortfoliosActions.PlannedPortfoliosActionTypes.CANCEL_TEMPORARY_PLANNED_PORTFOLIO:
            const cancelTempPlannedPortfolioState = {
                ...state
            };
            return tempPlannedPortfolioAdapter.removeOne(action.payload, cancelTempPlannedPortfolioState);
        case ModelPortfoliosActions.ModelPortfoliosActionTypes.SUBMIT_MODEL_PORTFOLIO_SUCCESS:
            const toBeRemovedSubscriptionIds = action.payload.subscriptions.map((s: IModelPortfolioSubscription) => s.id);
            return tempPlannedPortfolioAdapter.removeMany(toBeRemovedSubscriptionIds, state);
        default:
            return state;
    }
}
